/***
 * getFlattenedProjectLEadersFromForm gets RegionalPl values and BackupPLValues count to validate Project Leder Saves
 * @param formRef: ant form instance
 * @param setter func to set state
 */
export const getFlattenedProjectLeadersFromForm = (formRef) => {
  const leaders = [];
  const backupProjectLeader = formRef.getFieldValue("backupProjectLeader");
  if (backupProjectLeader) leaders.push(backupProjectLeader);
  const regionalProjectLeaders = formRef.getFieldValue("projectLeaders");
  if (regionalProjectLeaders) {
    Object.keys(regionalProjectLeaders).forEach((regionId) => {
      if (regionalProjectLeaders[regionId])
        leaders.push(regionalProjectLeaders[regionId]);
    });
  }
  return leaders;
};
